import type { InputBaseProps } from "@mui/material";
import { InputBase } from "@mui/material";
import classNames from "classnames";
import type { ReactNode } from "react";
import { PaperclipIcon } from "../../icons/PaperclipIcon";
import { SendMessageIcon } from "../../icons/SendMessageIcon";
import { AppIconButton } from "../AppIconButton";
import styles from "./styles.module.css";

type Props = InputBaseProps & {
  className?: string;
  sendButton?: boolean;
  fileButton?: boolean;
  small?: boolean;
  innerClassName?: string;
  inputValue?: string;
  setInputValue?: (value: string) => void;
  onSend?: (value: string) => void;
  onFileClick?: (e: any) => void;
  isSendDisabled?: boolean;
  handleSendKeyDown?: (event: any) => void;
  children?: ReactNode;
};

export const AppInputBase: React.FC<Props> = ({
  className,
  sendButton,
  fileButton,
  small,
  innerClassName,
  inputValue,
  setInputValue,
  onSend,
  onFileClick,
  isSendDisabled,
  disabled,
  handleSendKeyDown,
  children,
  ...props
}) => {
  const handleInputChange = (event: any): void => {
    if (setInputValue) setInputValue(event.target.value);
  };

  const handleSend = (e: any) => {
    if (!isSendDisabled && inputValue) onSend?.(inputValue);
  };

  const handleFileClick = (e: any) => {
    if (onFileClick) onFileClick(e);
  };

  return (
    <div className={styles.container}>
      <InputBase
        value={inputValue}
        className={classNames(
          styles.input,
          { [styles.send]: sendButton },
          { [styles.disabled]: disabled },
          className
        )}
        fullWidth
        onChange={handleInputChange}
        onKeyDown={handleSendKeyDown}
        classes={{
          input: classNames(
            styles.inner,
            { [styles.small]: small },
            innerClassName
          ),
        }}
        multiline
        disabled={disabled}
        {...props}
      />
      <div className={styles["button-container"]}>
        {fileButton && (
          <AppIconButton
            component="label"
            onClick={(e: any) => {
              e.target.value = null;
            }}
            className={classNames(styles["file-button"], {
              [styles.disabled]: disabled,
            })}
            disabled={isSendDisabled}
          >
            <input
              className={styles["upload-input"]}
              type="file"
              onChange={handleFileClick}
            />
            <PaperclipIcon className={styles.icon} />
          </AppIconButton>
        )}
        {sendButton && (
          <AppIconButton
            onClick={handleSend}
            className={classNames(styles["send-button"], {
              [styles.disabled]: isSendDisabled,
            })}
            disabled={isSendDisabled}
          >
            <SendMessageIcon className={styles.icon} />
          </AppIconButton>
        )}
        {children}
      </div>
    </div>
  );
};
